module.exports = __webpack_public_path__ + "static/media/pikto_krzyzowka.0cbc11b5.png";